/* MaxLife PDP - assets/maxlife-pdp.js  (Prestige + ReCharge selectors)
   1) Accordion: folds the .prose description's <h3> groups into <details> panels.
   2) Sticky add-to-cart: clones the theme's real "Add to cart" button (found by text
      inside the cart form) into a fixed bottom bar that appears after it scrolls off. */
(function () {
  function ready(fn){ if(document.readyState!=='loading') fn(); else document.addEventListener('DOMContentLoaded',fn); }

  function findDesc(){
    var h3=[...document.querySelectorAll('h3')].filter(function(h){return /why people choose|how to take|quality promise/i.test(h.textContent);});
    return h3.length ? h3[0].parentElement : null;
  }
  function findAtc(){
    var form=document.querySelector('form[action*="/cart/add"]');
    if(!form) return null;
    var btns=[...form.querySelectorAll('button, input[type=submit]')];
    return btns.find(function(b){ return /^\s*add to cart\s*$/i.test((b.textContent||b.value||'')); }) || null;
  }

  function buildAccordion(){
    var desc=findDesc();
    if(!desc || desc.dataset.mxAcc) return;
    var h3s=desc.querySelectorAll(':scope > h3');
    if(h3s.length<2) return;
    desc.dataset.mxAcc='1';
    var style=document.createElement('style');
    style.textContent=
      '.mx-acc{border-top:1px solid #e1e8ee;margin-top:16px}'+
      '.mx-acc details{border-bottom:1px solid #e1e8ee}'+
      '.mx-acc summary{list-style:none;cursor:pointer;display:flex;justify-content:space-between;align-items:center;padding:16px 0;font-family:Inter,system-ui,sans-serif;font-weight:600;font-size:15.5px;color:#0e1c2c}'+
      '.mx-acc summary::-webkit-details-marker{display:none}'+
      '.mx-acc summary::after{content:"+";font-weight:400;font-size:22px;color:#5b6b78;transition:transform .2s}'+
      '.mx-acc details[open] summary::after{transform:rotate(45deg)}'+
      '.mx-acc .mx-acc-body{padding:0 0 18px}'+
      '.mx-acc .mx-acc-body ul{padding-left:20px}'+
      '.mx-acc .mx-acc-body li{margin:0 0 8px}';
    document.head.appendChild(style);
    var wrap=document.createElement('div'); wrap.className='mx-acc'; var fine=null;
    h3s.forEach(function(h3,i){
      var d=document.createElement('details'); if(i===0) d.open=true;
      var s=document.createElement('summary'); s.textContent=h3.textContent.trim(); d.appendChild(s);
      var body=document.createElement('div'); body.className='mx-acc-body';
      var n=h3.nextSibling;
      while(n && !(n.nodeType===1 && n.tagName==='H3')){
        var next=n.nextSibling;
        if(n.nodeType===1 && /These statements have not been evaluated/i.test(n.textContent)){ fine=n; }
        else body.appendChild(n);
        n=next;
      }
      d.appendChild(body); wrap.appendChild(d); h3.remove();
    });
    desc.appendChild(wrap);
    if(fine) desc.appendChild(fine);
  }

  function buildSticky(){
    var mainBtn=findAtc();
    if(!mainBtn || document.querySelector('.mx-sticky')) return;
    var title=(document.querySelector('h1')||{}).textContent||document.title;
    var img=document.querySelector('[class*=gallery] img, main img');
    var priceEl=document.querySelector('.price-list, .price, [class*=price]');
    var style=document.createElement('style');
    style.textContent=
      '.mx-sticky{position:fixed;left:0;right:0;bottom:0;z-index:60;background:#fff;border-top:1px solid #e1e8ee;box-shadow:0 -6px 24px rgba(14,28,44,.08);transform:translateY(110%);transition:transform .25s ease;padding:10px 16px calc(10px + env(safe-area-inset-bottom,0px))}'+
      '.mx-sticky.is-on{transform:translateY(0)}'+
      '.mx-sticky .mx-in{max-width:1200px;margin:0 auto;display:flex;align-items:center;gap:14px}'+
      '.mx-sticky img{width:48px;height:48px;object-fit:contain;border-radius:8px;background:#f3f6f9}'+
      '.mx-sticky .mx-t{flex:1;min-width:0}'+
      '.mx-sticky .mx-t b{display:block;font-family:Inter,system-ui,sans-serif;font-size:14px;color:#0e1c2c;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}'+
      '.mx-sticky .mx-t span{font-family:Inter,system-ui,sans-serif;font-size:13px;color:#5b6b78}'+
      '.mx-sticky button{padding:13px 22px;border-radius:10px;border:0;background:#0e1c2c;color:#fff;font-family:Inter,system-ui,sans-serif;font-weight:600;font-size:14px;cursor:pointer;white-space:nowrap}'+
      '@media (max-width:600px){.mx-sticky img{display:none}.mx-sticky button{flex:1}}';
    document.head.appendChild(style);
    var bar=document.createElement('div'); bar.className='mx-sticky';
    bar.innerHTML='<div class="mx-in">'+(img?'<img src="'+(img.currentSrc||img.src)+'" alt="">':'')+'<div class="mx-t"><b></b><span></span></div><button type="button">Add to cart</button></div>';
    bar.querySelector('b').textContent=title.trim();
    var priceSpan=bar.querySelector('span');
    function syncPrice(){ if(priceEl) priceSpan.textContent=priceEl.textContent.replace(/\s+/g,' ').trim().slice(0,40); }
    syncPrice();
    if(priceEl) new MutationObserver(syncPrice).observe(priceEl,{childList:true,subtree:true,characterData:true});
    bar.querySelector('button').addEventListener('click',function(){ mainBtn.click(); var b=bar.querySelector('button'); b.textContent='Added \u2713'; setTimeout(function(){ b.textContent='Add to cart'; },1800); });
    document.body.appendChild(bar);
    var io=new IntersectionObserver(function(entries){ var e=entries[0]; var below=e.boundingClientRect.top<0; bar.classList.toggle('is-on', !e.isIntersecting && below); },{threshold:0});
    io.observe(mainBtn);
  }

  function run(){ buildAccordion(); buildSticky(); }
  ready(run);
  document.addEventListener('shopify:section:load', run);
  var tries=0; var iv=setInterval(function(){ run(); if(++tries>=10 || (document.querySelector('.mx-acc') && document.querySelector('.mx-sticky'))) clearInterval(iv); }, 800);
})();
